/**
 * Model/Normalizer para Reportes de Reservas
 * Este modelo se genera "al vuelo" uniendo datos de múltiples tablas
 */

export const reporteReservaModel = (data) => {
    return {
        // Identificadores
        idReserva: data.idReserva ?? data.IdReserva ?? 0,

        // Chofer
        nombreChofer: data.nombreChofer ?? data.NombreChofer ?? '',
        idChofer: data.idChofer ?? data.IdChofer ?? 0,

        // Fechas y Horas
        fechaInicio: data.fechaInicio ?? data.FechaInicio ?? '',
        horaInicio: data.horaInicio ?? data.HoraInicio ?? '',
        fechaFin: data.fechaFin ?? data.FechaFin ?? '',
        horaFin: data.horaFin ?? data.HoraFin ?? '',

        // Ubicaciones
        origen: data.origen ?? data.Origen ?? '',
        destino: data.destino ?? data.Destino ?? '',
        nombreVehiculo: data.nombreVehiculo ?? data.NombreVehiculo ?? '',

        // Solicitante
        nombreSolicitante: data.nombreSolicitante ?? data.NombreSolicitante ?? '',
        idSolicitante: data.idSolicitante ?? data.IdSolicitante ?? 0,

        // Motivo
        motivo: data.motivo ?? data.Motivo ?? '',

        // Empresa y Unidad Organizacional
        nombreEmpresa: data.nombreEmpresa ?? data.NombreEmpresa ?? '',
        idEmpresa: data.idEmpresa ?? data.IdEmpresa ?? 0,
        nombreUnidadOrganizacional: data.nombreUnidadOrganizacional ?? data.NombreUnidadOrganizacional ?? '',
        idUnidadOrganizacional: data.idUnidadOrganizacional ?? data.IdUnidadOrganizacional ?? 0,

        // Tipo de Aprobación
        nombreTipoAprobacion: data.nombreTipoAprobacion ?? data.NombreTipoAprobacion ?? '',
        idTipoAprobacion: data.idTipoAprobacion ?? data.IdTipoAprobacion ?? null,

        // Estado
        nombreEstado: data.nombreEstado ?? data.NombreEstado ?? '',
        idEstadoReserva: data.idEstadoReserva ?? data.IdEstadoReserva ?? 0,

        // Observaciones
        observaciones: data.observaciones ?? data.Observaciones ?? '',

        // Fecha de creación
        fechaCreacion: data.fechaCreacion ?? data.FechaCreacion ?? '',
    };
};

export default reporteReservaModel;
